import UNINITIALISED from "utils/uninitialised";
import {MaybeUninitialised} from "modules/redux_types";
import {GetLlmRunBatchesRecentAction} from "../actions/llm_run_batches_recent_fetch";
import actionTypes from "../constants/action_types";
import {LlmRunBatchInfo} from "common/flowmaster/types/llm_run";
import {ClearLlmRunsAction} from "../actions/llm_runs_clear";

export default function workflowsReducer(
  state: MaybeUninitialised<LlmRunBatchInfo[]> = UNINITIALISED,
  action: GetLlmRunBatchesRecentAction | ClearLlmRunsAction,
): typeof state {
  if (action.type === actionTypes.LLM_RUN_BATCHES_RECENT_FETCH.SUCCESS) {
    return (action as GetLlmRunBatchesRecentAction).payload;
  }

  if (action.type === actionTypes.LLM_RUNS_CLEAR.SUCCESS) {
    return UNINITIALISED;
  }

  return state;
}
